module.exports = __webpack_public_path__ + "static/img/admin-mgt.3ea89b8b.svg";